// getLivestreamLeaderboard.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import getListData from '../selector/getListData.js';
import {
  RANGE_SESSION,
  TOP_LEADERBOARD_USER_LEAST,
  liveStreamSessionLeaderboardCategory,
} from '../resource/liveStreamConstants.js';

const defaultList = [];

/**
 * Select livestream leaderboard by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - livestream stream id
 * @param {string} sessionId - livestream stream session id
 * @param {string} range - livestream leaderboard range
 * @param {string} category - livestream leaderboard category
 * @return {array} livestream leaderboard user Ids.
 */
const getLivestreamLeaderboard = createCachedSelector(
  (
    state,
    streamId,
    sessionId,
    range = RANGE_SESSION,
    category = liveStreamSessionLeaderboardCategory.TOTAL
  ) => {
    const selectPath =
      range === RANGE_SESSION
        ? [
            'liveStream',
            streamId,
            'session',
            sessionId,
            'leaderboard',
            category,
          ]
        : ['liveStream', streamId, 'leaderboard', range];
    return getListData(state, selectPath, 'itemIds');
  },
  (state, streamId, sessionId, range, category, maxSize = null) => maxSize,
  (userIds = defaultList, maxSize) => {
    if (userIds.length >= TOP_LEADERBOARD_USER_LEAST) {
      return maxSize !== null ? userIds.slice(0, maxSize) : userIds;
    }
    const placeholders = new Array(TOP_LEADERBOARD_USER_LEAST).fill(null);
    return [...userIds, ...placeholders].slice(0, TOP_LEADERBOARD_USER_LEAST);
  }
)(
  (state, streamId, sessionId, range, category) =>
    `${streamId}:${sessionId}:${range}:${category}`
);

export default getLivestreamLeaderboard;
